import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { URL } from '../../assets/js/constants';

export function carregarDadosFuncionarios(data) {
    return {
        type: 'FUNCIONARIOS_FETCHED',
        payload: data
    }
}

export function carregarDadosFuncionario(data) {
    return {
        type: 'FUNCIONARIO_FETCHED',
        payload: data
    }
}

function funcionarioProcessing(data) {
    return {
        type: 'FUNCIONARIO_PROCESSING',
        payload: data
    }
}


function funcionarioLoading(data) {
    return {
        type: 'FUNCIONARIO_LOADING',
        payload: data
    }
}

export function getFuncionarios() {
    return dispatch => {
        dispatch(funcionarioLoading(true));
        axios.get(`${URL}/funcionarios/gestao/todos-funcionarios`)
            .then(resp => {
                dispatch(carregarDadosFuncionarios(resp.data));
                dispatch(funcionarioLoading(false));
            })
            .catch(e => {
                dispatch(funcionarioLoading(false));
                toastr.error('Erro', 'Não foi possível atualizar lista de funcionários. Erro: ' + e.message);
            })
    }
}

export function getFuncionariosDoNegocio(idNegocio) {
    return dispatch => {
        dispatch(funcionarioLoading(true));
        axios.get(`${URL}/funcionarios/meu-negocio/ativos/${idNegocio}`)
            .then(resp => {
                dispatch(carregarDadosFuncionarios(resp.data));
                dispatch(funcionarioLoading(false));
            })
            .catch(e => {
                dispatch(funcionarioLoading(false));
                toastr.error('Erro', 'Não foi possível atualizar lista de funcionários. Erro: ' + e.message);
            })
    }
}

export function getFuncionario(idFuncionario) {
    return dispatch => {
        dispatch(funcionarioLoading(true));
        axios.get(`${URL}/funcionarios/${idFuncionario}`)
            .then(resp => {
                dispatch(carregarDadosFuncionario(resp.data))
                dispatch(funcionarioLoading(false));
            })
            .catch(e => {
                dispatch(funcionarioLoading(false));
                toastr.error('Erro', 'Não foi possível encontrar o funcionario. Erro: ' + e.message)
            })
    }
}

export function cadastrarSenha(values) {
    return dispatch => {
        axios.get(`${URL}/funcionarios/cadastrar-senha`, values)
            .then(_ => toastr.success('Sucesso', 'Senha cadastrada com sucesso.')
                .catch(e => toastr.error('Erro', 'Ocorreu um erro no servidor. Tente novamente mais tarde.')))
    }
}

export function alterarSenha(values) {
    return dispatch => {
        axios.put(`${URL}/funcionarios/alterar-senha`, values)
            .then(_ => toastr.success('Sucesso', 'Senha alterada com sucesso.'))
            .catch(e => toastr.error('Erro', 'A senha atual não confere. Tente novamente.'))
    }
}

export function addFuncionario(values) {
    return dispatch => {
        dispatch(funcionarioProcessing(true));
        axios.post(`${URL}/funcionarios/novo-funcionario`, values)
            .then(_ => {
                dispatch(getFuncionariosDoNegocio(values.idNegocio));
                dispatch(funcionarioProcessing(false));
                toastr.success('Sucesso', 'Funcionário cadastrado com sucesso.');
            })
            .catch(e => {
                dispatch(funcionarioProcessing(false));
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function editFuncionario(values) {
    return dispatch => {
        dispatch(funcionarioProcessing(true));
        axios.put(`${URL}/funcionarios/alterar`, values)
            .then(_ => {
                dispatch(getFuncionariosDoNegocio(values.idNegocio));
                dispatch(funcionarioProcessing(false));
                toastr.success('Sucesso', 'Funcionário atualizado com sucesso.');
            })
            .catch(e => {
                dispatch(funcionarioProcessing(false));
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}